export default "__VITE_ASSET__66eb4c99__"